import { AuthClientInstance, getAuthClient } from "@trumpf/ux.utils";
import { getEnvConfig } from "../config/api";

const authClientServiceCalls: AuthClientInstance = getAuthClient();

/**
 * this uses an IDM access token to create a TBDB access token (ticket)
 * @returns string | null - token
 */
export const createTicket = async function (): Promise<string> {
    const token = authClientServiceCalls.getAccessToken();
    if (!token) {
        return Promise.reject("No access token");
    }
    const { baseUrl, publicAPIVersion, publicAPIClientType } = getEnvConfig();
    return fetch(baseUrl + "/user/createticket", {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token
        },
        body: JSON.stringify({
            clientType: publicAPIClientType,
            apiVersion: publicAPIVersion
        })
    })
        .then((response) => response.json())
        .then((data: { token: string }) => {
            return data?.token || null;
        });
};
